export var Debounce;
(function (Debounce) {
    Debounce[Debounce["MIN"] = 100] = "MIN";
    Debounce[Debounce["DEFAULT"] = 800] = "DEFAULT";
    Debounce[Debounce["LAZY"] = 1200] = "LAZY";
})(Debounce || (Debounce = {}));
